import { SEO } from "@/components/SEO";
import { InstLayout, Container, Eyebrow } from "@/components/institutional/InstLayout";
import { ArrowRight } from "lucide-react";

const USE_CASES = [
  { href: "/use-cases/early-warning/", title: "Early-warning signals", desc: "Surface behavioral shifts weeks before traditional academic indicators move." },
  { href: "/use-cases/retention/", title: "Retention support", desc: "Help retention teams identify students who may benefit from earlier outreach." },
  { href: "/use-cases/advising-workflows/", title: "Advising workflows", desc: "Triage caseloads with explainable behavioral context, not GPA proxies." },
  { href: "/use-cases/first-year-experience/", title: "First-year experience", desc: "Add a behavioral lens to FYE programs at the moment engagement matters most." },
  { href: "/use-cases/online-program-engagement/", title: "Online program engagement", desc: "Visibility into async and hybrid program engagement quality." },
  { href: "/use-cases/at-risk-cohorts/", title: "At-risk cohorts", desc: "Cohort-level visibility across programs, terms, and populations." },
  { href: "/use-cases/study-habits-insight/", title: "Study habits insight", desc: "Behavioral learning patterns at the individual and cohort level." },
  { href: "/use-cases/research-behavioral-data/", title: "Research-grade behavioral data", desc: "Anonymized datasets for learning-science and institutional research teams." },
];

const UseCasesIndex = () => (
  <InstLayout>
    <SEO
      title="Use Cases — Behavioral Intelligence for Student Success"
      description="How student success teams put CSW to work: early-warning signals, retention support, advising workflows, FYE, online program engagement, cohort visibility, and research data."
      canonicalUrl="/use-cases/"
    />
    <Container>
      <header className="max-w-3xl mb-16">
        <Eyebrow>Use cases</Eyebrow>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] mb-6">
          How student success teams put CSW to work.
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
          Outcome-focused use cases that span audiences. Every use case is built on explainable
          behavioral signals and is designed to support — not replace — human judgment.
        </p>
      </header>
      <div className="grid sm:grid-cols-2 gap-5">
        {USE_CASES.map((u) => (
          <a key={u.href} href={u.href} className="rounded-2xl border border-border bg-card p-7 hover:border-primary/50 transition-colors group">
            <h2 className="font-display text-xl font-semibold mb-2">{u.title}</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">{u.desc}</p>
            <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary group-hover:gap-2 transition-all">
              Read use case <ArrowRight className="w-4 h-4" />
            </span>
          </a>
        ))}
      </div>
    </Container>
  </InstLayout>
);
export default UseCasesIndex;
